import React, { useMemo } from 'react';
import Box from '../../common/Box';
import styles from './UserEmailNotifications.module.scss';
import { isEmpty } from 'lodash';

import {
  generalNotifications,
  supplierNotifications,
  retailerNotifications,
} from '../../../constants/emailNotifications';
import NotificationTable from './NotificationTable';
import { useSelector } from 'react-redux';
import Spinner from '../../common/Spinner';
import cn from 'classnames';

function UserEmailNotifications() {
  const { loadUserNotifications, user } = useSelector((state) => state.role);
  const hasSuppliers = useMemo(() => user.suppliers.length > 0, [user]);
  const hasRetailers = useMemo(() => user.retailers.length > 0, [user]);

  return (
    <Box
      toolbar="Email Notifications"
      className={cn(styles.notificationsWrapper, loadUserNotifications ? 'disableUserEvents' : '')}
    >
      {loadUserNotifications && <Spinner fixed absolute size="large" />}

      {!isEmpty(generalNotifications) && (
        <NotificationTable notifications={generalNotifications} title="General Notifications" />
      )}
      {hasSuppliers && !isEmpty(supplierNotifications) && (
        <NotificationTable notifications={supplierNotifications} title={hasRetailers ? 'Supplier' : ''} />
      )}
      {user.retailers.length > 0 && !isEmpty(retailerNotifications) && (
        <NotificationTable notifications={retailerNotifications} title={hasSuppliers ? 'Retailer' : ''} />
      )}
    </Box>
  );
}

export default UserEmailNotifications;
